import { render, staticRenderFns } from "./AOI_Item.vue?vue&type=template&id=740c1372&scoped=true&"
import script from "./AOI_Item.vue?vue&type=script&lang=js&"
export * from "./AOI_Item.vue?vue&type=script&lang=js&"
import style0 from "./AOI_Item.vue?vue&type=style&index=0&id=740c1372&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740c1372",
  null
  
)

export default component.exports